import React from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";
import { useLang } from "../contexts/LangContext";
import { formatErrorDetail } from "../lib/api";

export default function AdminLogin() {
  const { t } = useLang();
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (user) nav("/admin");
  }, [user, nav]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Accesso effettuato");
      nav("/admin");
    } catch (err) {
      toast.error(formatErrorDetail(err?.response?.data?.detail) || t.common.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a] py-32 px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-white/10 p-10 bg-[#0e0e0e]">
        <div className="flex items-center gap-3 mb-8">
          <img src="/logo.png" alt="Scudieri Group" className="h-14 w-auto" />
          <div>
            <div className="font-display text-xs text-[color:var(--gold)]">Scudieri Group</div>
            <div className="font-display font-semibold text-base text-white">{t.admin.title}</div>
          </div>
        </div>
        <form onSubmit={onSubmit} className="space-y-7" data-testid="admin-login-form">
          <label className="block">
            <span className="font-display text-[10px] tracking-[0.32em] uppercase text-[color:var(--gold)]">
              {t.admin.email}
            </span>
            <input
              type="email"
              className="field mt-1"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              data-testid="admin-login-email"
            />
          </label>
          <label className="block">
            <span className="font-display text-[10px] tracking-[0.32em] uppercase text-[color:var(--gold)]">
              {t.admin.password}
            </span>
            <input
              type="password"
              className="field mt-1"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-login-password"
            />
          </label>
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="admin-login-submit">
            {loading ? t.common.sending : t.admin.login}
            {!loading && <ArrowRight className="w-4 h-4" />}
          </button>
        </form>
      </div>
    </div>
  );
}
